import { ModalWrapper } from 'src/components'
import { ProductViewsGraph } from './product-views-graph.component'

import { useStyles } from './styles'

interface IProductViewsDashboardModalProps {
  open: boolean
  handleClose: () => void
  productId: string
  productName: string
}

const ProductViewsDashboardModal = ({
  open,
  handleClose,
  productId,
  productName,
}: IProductViewsDashboardModalProps) => {
  const classes = useStyles()

  return (
    <ModalWrapper
      onClose={handleClose}
      className={classes.modalWrapper}
      open={open}
      title={productName}
    >
      <div style={{ width: '100%', height: '100%' }}>
        <ProductViewsGraph productId={productId} />
      </div>
    </ModalWrapper>
  )
}

export { ProductViewsDashboardModal }
